enum RouteLineUrlKeys {
  QUARTER = "quarter",
}

export default RouteLineUrlKeys;
